const URL_REGEX = /(?<!<a[^>]*?>)(https?:\/\/[^\s<]+)(?![^<]*?<\/a>)/g;

export interface LinkifyTextProps {
  text: string;
}

export const LinkifyText = ({ text }: LinkifyTextProps) => {
  const parts = text.split(URL_REGEX);

  const linifiedText = parts
    .map((part, index) =>
      URL_REGEX.test(part)
        ? `<a href=${part} target="_blank" rel="noopener noreferrer">${part}</a>`
        : part
    )
    .join('');

  return <p dangerouslySetInnerHTML={{ __html: linifiedText }}></p>;
};
